import { Table } from 'antd';
import React from 'react';

const QuestionTable = ({ data, columns, selectedQuestion, onSelect }) => {
  return (
    <Table
      rowKey="id"
      columns={columns}
      dataSource={data}
      pagination={{
        pageSize: 8,
        showSizeChanger: false,
      }}
      style={{ border: '1px solid #E6E6E6', marginTop: 10, borderRadius: 3 }}
      rowClassName={r =>
        selectedQuestion && r.id === selectedQuestion.id ? 'question-table__selected' : ''
      }
      onRow={r => ({ onClick: () => onSelect(r), style: { cursor: 'pointer' } })}
    />
  );
};

export default QuestionTable;
